// The kinds of document a patient can upload — one list for every organisation, the same keys as
// server/src/services/documentTypes.ts (a test keeps both lists equal). Labels live in the locale
// files under `documentTypes.<key>`; PsyCloud files each upload under its type (Linear PSY-1116).
export const DOCUMENT_TYPES = [
  'external_reports',
  'certificates',
  'ecg',
  'bloodwork',
  'medication',
  'questionnaires',
  'insurance_documents',
  'authority_documents',
  'identity_documents',
  'ptv11',
  'absageprotokoll',
  'konsiliarbericht',
  'other',
] as const
export type DocumentType = typeof DOCUMENT_TYPES[number]

/**
 * Psychotherapy documents: requested on a case's link only (server vertraegeFinalize.ts), never in
 * a patient's free choice — every other patient would wonder what a "PTV 11" is.
 */
export const REQUEST_ONLY_DOCUMENT_TYPES: readonly DocumentType[] = ['ptv11', 'absageprotokoll', 'konsiliarbericht']

/** What a patient can pick for a file themselves (the upload step and the upload page's dropdown) */
export const CHOOSABLE_DOCUMENT_TYPES: readonly DocumentType[] = DOCUMENT_TYPES.filter(t => !REQUEST_ONLY_DOCUMENT_TYPES.includes(t))

/**
 * What staff can ask a patient for on a link (Admin → Uploads and booking's "Upload-Link senden"):
 * the types with their own PsyCloud category. Everything else would land in "Sonstige" anyway, so
 * staff send an unspecific link instead and the patient says what each file is (Paul, 2026-10-15).
 */
export const REQUESTABLE_DOCUMENT_TYPES = ['ecg', 'bloodwork', 'external_reports', 'certificates'] as const

export function isDocumentType(value: unknown): value is DocumentType {
  return typeof value === 'string' && (DOCUMENT_TYPES as readonly string[]).includes(value)
}
